module.exports = __webpack_public_path__ + "img/red.688cb96e.png";